//GALLERY - RENDERS
export const galleryRenders01 = [
	{ title: '1', rollOver: "Building Hero", caption: [''], src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-01.jpg', href: '/img/gallery-renders/gallery-renders-01.jpg' },
	{ title: '2', rollOver: "Rooftop Pool", caption: [''],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-02.jpg', href: '/img/gallery-renders/gallery-renders-02.jpg' },
	{ title: '3', rollOver: "Rooftop BBQ Lounge", caption: [''],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-03.jpg', href: '/img/gallery-renders/gallery-renders-03.jpg' },
	{ title: '4', rollOver: "Rooftop BBQ Dining", caption: [''],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-04.jpg', href: '/img/gallery-renders/gallery-renders-04.jpg' },
	{ title: '5', rollOver: "2BR U504 Living + Kitchen", caption: [''],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-05.jpg', href: '/img/gallery-renders/gallery-renders-05.jpg' },
	{ title: '6', rollOver: "2BR U504 Kitchen", caption: [""],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-06.jpg', href: '/img/gallery-renders/gallery-renders-06.jpg' },
	{ title: '7', rollOver: "2BR U504 Master Bedroom", caption: [""], src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-07.jpg', href: '/img/gallery-renders/gallery-renders-07.jpg' },
	{ title: '8', rollOver: "2BR U504 Ensuite", caption: [''], src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-08.jpg', href: '/img/gallery-renders/gallery-renders-08.jpg' },
	{ title: '9', rollOver: "3BR U501 Living + Balcony", caption: [""],src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-09.jpg', href: '/img/gallery-renders/gallery-renders-09.jpg' },
	{ title: '10',rollOver: "3BR U501 Kitchen", caption: [''], src: '/img/gallery-renders/4K_Thumbnails/gallery-tmb-renders-10.jpg', href: '/img/gallery-renders/gallery-renders-10.jpg' },
	//{ title: '11', left: '960px', top: '640px',rollOver: "The Bathhouse Lounge Area", caption: ['The Bathouse Lounge Area'], src: '/img/gallery-renders/gallery-tmb-renders-11.jpg', href: '/img/gallery-renders/gallery-renders-11.jpg' },
	//{ title: '12', left: '1390px', top: '640px', rollOver: 'The Bathhouse 25m Pool', caption: ['The Bathouse 25m Pool'],src: '/img/gallery-renders/gallery-tmb-renders-12.jpg', href: '/img/gallery-renders/gallery-renders-12.jpg' },
];

//INTERIOR - FINISHES
export const interiorFinishes01 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-finishes/interior-finishes-01.jpg' },
];
export const interiorFinishes02 = [
	{ title: '2', left: '0px', top: '0px', src: '/img/interior-finishes/interior-finishes-02.jpg' },
];
export const interiorFinishes03 = [
	{ title: '3', left: '0px', top: '0px', src: '/img/interior-finishes/interior-finishes-3.jpg' },
];
export const interiorFinishes04 = [
	{ title: '4', left: '0px', top: '0px', src: '/img/interior-finishes/interior-finishes-4.jpg' },
];

//TEAM
export const Team01 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/team/team-01.jpg' },
];

//LIFESTYLE
export const Lifestyle01 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/lifestyle/lifestyle-01.jpg' },
];
	export const Lifestyle02 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/lifestyle/lifestyle-02.jpg' },
];

//INTERIOR IMAGES
export const InteriorImages01 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-01.jpg' },
];
export const InteriorImages02 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-02.jpg' },
];
export const InteriorImages03 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-03.jpg' },
];
export const InteriorImages04 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-04.jpg' },
];
export const InteriorImages05 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-05.jpg' },
];
export const InteriorImages06 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-06.jpg' },
];
export const InteriorImages07 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/interior-images/interiors-07.jpg' },
];


//DESIGN
export const design01 = [
	{ title: '1', left: '0px', top: '0px', src: '/img/design/design-01.jpg' },
];
export const design02 = [
	{ title: '2', left: '0px', top: '0px', src: '/img/design/design-02.jpg' },
];
export const design03 = [
	{ title: '2', left: '0px', top: '0px', src: '/img/design/design-03.jpg' },
];
export const design04 = [
	{ title: '2', left: '0px', top: '0px', src: '/img/design/design-04.jpg' },
];
export const design05 = [
	{ title: '2', left: '0px', top: '0px', src: '/img/design/design-05.jpg' },
];